import moment from "moment/moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useReactToPrint } from "react-to-print";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import ModalContainer from "../../../../components/modals/ModalContainer";
import SelectPolicy from "../../../../components/modals/customers/create/SelectPolicy";
import PaginationLinks from "../../../../components/pagination/PaginationLinks";
import PageTitle from "../../../../components/partials/PageTitle";
import { getGlAccounts } from "../../../../redux/slice/accounting/accountingSlice";
import { getFilteredPolicies } from "../../../../redux/slice/policy/policySlice";
import {
  getSavingsPolicies,
  resetSinglePolicy,
} from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { policyCategories } from "../../../../utils/data/constant";
import { addEllipses } from "../../../../utils/helpers/filter";

const SavingsPolicy = () => {
  const { user } = useSelector((state) => state?.auth?.user);
  const { savingsPolicyConfig } = useSelector((state) => state?.savingsPolicy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [hasAddPolicy, setHasAddPolicy] = useState();
  const [hasViewPolicy, setHasViewPolicy] = useState();

  const generatePDF = useReactToPrint({
    content: () => pdfRef.current,
    documentTitle: "all_savings_policies",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();
  const today = moment();

  const memoizedPolicy = useMemo(() => {
    if (!Array.isArray(savingsPolicyConfig?.data)) {
      const arr =
        savingsPolicyConfig?.data && Object.values(savingsPolicyConfig?.data);
      return arr;
    }
    return savingsPolicyConfig?.data;
  }, [savingsPolicyConfig]);

  // export data to excel file
  const exportXlsxData = useMemo(() => {
    return memoizedPolicy?.map((item) => ({
      Name: item?.name,
      Description: item?.description,
      "Expiring Date": item?.expires_at,
    }));
  }, [memoizedPolicy]);

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Savings Policies",
      link: "/admin/savings-policy",
    },
    current: {
      title: "All",
      link: null,
    },
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [filterBy, setFilterBy] = useState("");
  const pdfRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      getFilteredPolicies({
        pageNumber: 1,
        office_id: user?.office_id,
        search: filterBy,
      })
    );
  };

  // fetch staff list on click of pagination links
  const fetchStaffsHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(
      getSavingsPolicies({ pageNumber: pageNum, office_id: user?.office_id })
    );
  };

  useEffect(() => {
    dispatch(getSavingsPolicies({ pageNumber: 1, office_id: user?.office_id }));
    dispatch(getGlAccounts());
    dispatch(resetSinglePolicy());
  }, []);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "policy configuration module"
      )
    ) {
      navigate("/admin/dashboard");
    }
    setHasAddPolicy(
      user_permissions?.some(
        (permission) => permission.name === "create policy"
      )
    );
    setHasViewPolicy(
      user_permissions?.some(
        (permission) => permission.name === "view policy details"
      )
    );
  }, [navigate, user_permissions]);

  if (!savingsPolicyConfig) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      <PageTitle title='Available Savings Policies' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
          <div
            className={`d-flex ${
              hasAddPolicy ? "justify-content-between" : "justify-content-end"
            } align-items-center`}
          >
            {hasAddPolicy && (
              <div>
                <Link
                  type='button'
                  className='btn btn-sm btn-primary'
                  to='/admin/savings-policy/create'
                >
                  Create Savings Policy
                </Link>
              </div>
            )}
            <div className='d-flex justify-content-between align-items-center gap-3'>
              <form
                onSubmit={handleSubmit}
                className='d-flex bg-primary-1 align-items-center '
                style={{ height: "30px", width: "217px" }}
              >
                <input
                  type='search'
                  value={filterBy}
                  className='border-0'
                  placeholder='Search...'
                  onChange={(e) => setFilterBy(e.target.value)}
                  style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button
                  type='submit'
                  className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                  style={{ height: "28px" }}
                >
                  <i className='uil uil-search text-white fs-4'></i>
                </button>
              </form>
              <div className=' d-flex align-items-center border '>
                <span
                  className='bg-info me-2 text-white'
                  style={{ padding: "3px" }}
                >
                  Export to
                </span>

                <span
                  href='#'
                  id='btnExport'
                  className='me-1'
                  title='Export to Pdf'
                  onClick={generatePDF}
                >
                  <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                </span>

                {/* <CSVLink
                  data={exportXlsxData}
                  style={{ fontWeight: "bolder" }}
                  filename='Available Policies'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink> */}
              </div>
            </div>
          </div>
        </div>
        <div className=''>
          <div className='col-12'>
            <div className='row'>
              <div className='col-sm-12'>
                {savingsPolicyConfig?.data?.length < 1 ? (
                  <h5 className='alert alert-info'>Result not found!</h5>
                ) : (
                  <>
                    <div className='table-responsive' ref={pdfRef}>
                      <table className='table table-centered table-striped nowrap w-100 no-footer'>
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "220.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Name
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              //   style={{ width: "250.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Description
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              Status
                            </th>
                            {hasViewPolicy && (
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "86.8px" }}
                              >
                                Action
                              </th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {memoizedPolicy?.map((item, i) => {
                            const expirationDate = moment(
                              item?.expires_at,
                              "YYYY-MM-DD"
                            );
                            return (
                              <tr style={{ lineHeight: "15px" }} key={i}>
                                <td>{item?.name}</td>
                                <td className='table-user'>
                                  {addEllipses(item?.description, 80)}
                                </td>
                                <td className='table-user'>
                                  <span
                                    className={`badge fw-normal rounded-4 ${
                                      expirationDate.isBefore(today)
                                        ? "badge-warning-lighten"
                                        : "badge-success-lighten"
                                    }`}
                                    style={{
                                      fontSize: "10px",
                                      padding: "5px 18px",
                                    }}
                                  >
                                    {expirationDate.isBefore(today)
                                      ? "Expired"
                                      : "Active"}
                                  </span>
                                </td>
                                {hasViewPolicy && (
                                  <td className='text-dark'>
                                    <Link
                                      to={`/admin/edit-savings-policy/${item.id}`}
                                    >
                                      <i className='mdi mdi-pencil fs-3 cursor-p'></i>
                                    </Link>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className='row mt-2'>
                      <div className='col-sm-12 col-md-6'>
                        <div
                          className='dataTables_info table-pages'
                          id='products-datatable_info'
                          role='status'
                          aria-live='polite'
                        >
                          Showing policies {savingsPolicyConfig?.from} to{" "}
                          {savingsPolicyConfig?.to} of{" "}
                          {savingsPolicyConfig?.total}
                        </div>
                      </div>
                      <div className='col-sm-12 col-md-6'>
                        <PaginationLinks
                          paginationData={savingsPolicyConfig}
                          getNextPage={fetchStaffsHandler}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <ModalContainer modal_id='select-policy' modal_width='modal-sm'>
          <SelectPolicy categories={policyCategories} />
        </ModalContainer>
      </div>
    </>
  );
};

export default SavingsPolicy;
